import Input from '../../components/Input/Input';
import ConfigurationHeader from '../../components/heading/ConfigurationHeader';
import BorderHeading from '../../components/heading/BorderHeading';
import QuestionHeading from '../../components/heading/QuestionHeading';
import { IndentWrapper } from '../orderConfiguration/OrderConfiguration';
import { DashboardCheckbox } from '../../components/Input/Input';
import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import * as yup from 'yup';
import {
  passwordConfigurationValueType,
  configurationAttributeType,
} from '../../types';
import {
  convertValuesToConfig,
  createValidation,
  doFinalConfigSubmit,
  getMetaDataConfig,
  getNewConfiguration,
  postConfiguration,
  updateConfiguration,
} from '../../services/uiConfigService';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import { openPopup } from '../../stateManagement/actions/popupActions';
import GenricMultiSelect from '../../components/Input/GenericMultiSelect';
import { ChannelkartNetworkGet } from '../../services/networkService';
import './PasswordConfiguration.css';
import { defaultPasswordConfigurationValues } from '../defaultConfigurations/passwordConfigDefaultValues';


const PasswordConfiguration = () => {
  const [passwordConfig, setpasswordConfig] = useState<
    configurationAttributeType[]
  >([]);
  const [allDesignations, setAllDesignations] = useState<string[]>([]);
  const [values, setValues] = useState<passwordConfigurationValueType>(
    deepClone(defaultPasswordConfigurationValues)
  );
  const [passwordValidationsSchema, setpasswordValidationsSchema] = useState(
    {}
  );

  useEffect(() => {
    const getpasswordConfiguration = async () => {
      try {
        const resp = await getNewConfiguration('password_configuration');
        const password_config: configurationAttributeType[] =
          resp?.domainValues;
        setpasswordConfig([...password_config]);
      } catch (err) {
        // Sentry.captureException(err);
      }
    };
    getpasswordConfiguration();
  }, []);

  useEffect(() => {
    const getRoleDivisionData = async () => {
      try {
        const response = await ChannelkartNetworkGet(
          '/v1/divisions?sort=level:asc&size=100&source=portal&callType=scheduled'
        );
        const features = response.data.features;

        const tempDesignations: string[] = [];
        features.forEach((feature: any) => {
          if(feature.divisionName){
            tempDesignations.push(feature.divisionName);
          }
        });
        setAllDesignations(tempDesignations);
      } catch (err) {
        // Sentry.captureException(err);
      }
    };
    getRoleDivisionData();
  }, []);

  const setpasswordConfigValues = () => {
    try {
      if (passwordConfig.length) {
        const result = { ...values } as { [key: string]: unknown };
        
        passwordConfig.forEach(attr => {
     
          result[attr.name] = attr;
        });
        setValues({ ...(result as passwordConfigurationValueType) });
 
      }
    } catch (err) {
      // Sentry.captureException(err);
    }
  };

  useEffect(() => {
    setpasswordConfigValues();
  }, [passwordConfig]);

  function validatePasswordConfiguration(){
    const loginConfig = values.userLoginBlock.value;
    const keysArr =  Object.keys(loginConfig);
   for(let key of keysArr){
      const applicationTypeObj = loginConfig[key as "app" | "portal"];
      if(applicationTypeObj.numberOfAttemptsAllowed && parseFloat(applicationTypeObj.numberOfAttemptsAllowed)<0){
        openPopup("Error","The number of Attempts can't be negative");
        return false;
      }
      if(applicationTypeObj.numberOfMinutesToBeBlocked && parseFloat(applicationTypeObj.numberOfMinutesToBeBlocked)<0){
        openPopup("Error","The number of Attempts can't be negative");
        return false;
      }
      if(applicationTypeObj.timePeriod && parseFloat(applicationTypeObj.timePeriod)<0){
        openPopup("Error","Time period can't be negative");
        return false;
      }
    }
    return true;
  }

  const saveConfiguration = async (preview?: boolean) => {
    const isValid = validatePasswordConfiguration();
    if(!isValid){
      return;
    }
      try {
        const configName = 'password_configuration';
      
        const validationObject: any = {};
        const convertedVal=convertValuesToConfig(values, passwordConfig);;
        await doFinalConfigSubmit(configName,convertedVal);
      } catch (err) {
        // Sentry.captureException(err);
        console.log('err===', err);
        if (err instanceof Error)
          openPopup('Error', 'Validation Error occured : ' + err?.message);
      }
  };

  const handleAppCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyName = e.target.name;
    setValues({
      ...values,
    userLoginBlock: {
      ...values.userLoginBlock,
      value:{
        ...values.userLoginBlock.value,
        app:{
          ...values.userLoginBlock.value.app,
          [keyName]:e.target.checked,
        }
      }  
      },
    });
  };

  const handleAppValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyName = e.target.name;
    const abc = Number(e.target.value);
    if (Number(e.target.value) < 0 ) return;
    setValues({
      ...values,
    userLoginBlock: {
      ...values.userLoginBlock,
      value:{
        ...values.userLoginBlock.value,
        app:{
          ...values.userLoginBlock.value.app,
          [keyName]:e.target.value,
        }
      }
      },
    });
  };

  const handlePortalCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyName = e.target.name;
    setValues({
    ...values,
    userLoginBlock: {
      ...values.userLoginBlock,
      value:{
        ...values.userLoginBlock.value,
          portal:{
            ...values.userLoginBlock.value.portal,
            [keyName]:e.target.checked,
          }
        }  
      },
    });
  };

  const handlePortalValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyName = e.target.name;
    if (Number(e.target.value) < 0) return;
    setValues({
      ...values,
    userLoginBlock: {
      ...values.userLoginBlock,
      value:{
        ...values.userLoginBlock.value,
        portal:{
          ...values.userLoginBlock.value.portal,
          [keyName]:e.target.value,
        }
      }
      },
    });
  };
  const handleKeyDown = (event: any) => {
    if (event.key === '-' || event.key === 'e') {
        event.preventDefault();
    }
};
  const handleInactivityValueChnage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyName = e.target.name;
    if (Number(e.target.value) < 0) return;
    setValues({
      ...values,
    userInactivityBlock: {
      ...values.userInactivityBlock,
      value:{
        ...values.userInactivityBlock.value,
        [keyName]:e.target.value,
        }
      },
    });
  };


  

  return (
    <div className='customer_config_container'>
      <ConfigurationHeader
        heading={'Password Configuration'}
        saveConfiguration={saveConfiguration}
        createPreview={() => {}}
      />

      <div className='config_form_container'>
        <div className='form_header'>
          <BorderHeading>Password Retry Configration</BorderHeading>
        </div>

        <IndentWrapper indent={1}>
          <QuestionHeading>Block Users on App?</QuestionHeading>
          <div className='answer_container'>
            <DashboardCheckbox
              onChange={handleAppCheckChange}
              checked={values?.userLoginBlock?.value?.app?.blockUser}
              name='blockUser'
              label='Yes'
            />
          </div>
        </IndentWrapper>

        <IndentWrapper indent={2}>
          <QuestionHeading>Number Of Attempts Allowed In App</QuestionHeading>
          <div className='answer_container'>
            <Input
              value={values?.userLoginBlock?.value?.app?.numberOfAttemptsAllowed}
              onChange={(e)=>{
                handleAppValueChange(e as  React.ChangeEvent<HTMLInputElement> )
              }
            }
              onKeyDown={handleKeyDown}
              name='numberOfAttemptsAllowed'
              type='number'
              
            />
          </div>
        </IndentWrapper>

        <IndentWrapper indent={2}>
          <QuestionHeading>
            Number Of Minutes To Be Blocked On App
          </QuestionHeading>
          <div className='answer_container'>
            <Input
              value={values?.userLoginBlock?.value?.app?.numberOfMinutesToBeBlocked}
              onChange={handleAppValueChange}
              name='numberOfMinutesToBeBlocked'
              onKeyDown={handleKeyDown}
              type='number'
            />
          </div>
        </IndentWrapper>

        <IndentWrapper indent={2}>
          <QuestionHeading>Unblock after time period on app?</QuestionHeading>
          <div className='answer_container'>
            <DashboardCheckbox
              onChange={handleAppCheckChange}
              checked={values?.userLoginBlock?.value?.app?.unblockAfterTimePeriod}
              name='unblockAfterTimePeriod'
              label='Yes'
            />
          </div>
        </IndentWrapper>

        <IndentWrapper indent={2}>
          <QuestionHeading>Time Period In App</QuestionHeading>
          <div className='answer_container'>
            <Input
              value={values?.userLoginBlock?.value?.app?.timePeriod}
              onChange={handleAppValueChange}
              name='timePeriod'
              onKeyDown={handleKeyDown}
              type='number'
            />
          </div>
        </IndentWrapper>

        <IndentWrapper indent={1}>
          <QuestionHeading>Block Users On Portal?</QuestionHeading>
          <div className='answer_container'>
            <DashboardCheckbox
              onChange={handlePortalCheckChange}
              checked={values?.userLoginBlock?.value?.portal?.blockUser}
              name='blockUser'
              label='Yes'
            />
          </div>
        </IndentWrapper>

        <IndentWrapper indent={2}>
          <QuestionHeading>Number Of Attempts Allowed In Portal</QuestionHeading>
          <div className='answer_container'>
            <Input
              value={values?.userLoginBlock?.value?.portal?.numberOfAttemptsAllowed}
              onChange={handlePortalValueChange}
              name='numberOfAttemptsAllowed'
              type='number'
              onKeyDown={handleKeyDown}
            />
          </div>
        </IndentWrapper>

        <IndentWrapper indent={2}>
          <QuestionHeading>
            Number Of Minutes To Be Blocked On Portal
          </QuestionHeading>
          <div className='answer_container'>
            <Input
              value={values?.userLoginBlock?.value?.portal?.numberOfMinutesToBeBlocked}
              onChange={handlePortalValueChange}
              name='numberOfMinutesToBeBlocked'
              type='number'
              onKeyDown={handleKeyDown}
            />
          </div>
        </IndentWrapper>

        <IndentWrapper indent={2}>
          <QuestionHeading>Unblock after time period on portal?</QuestionHeading>
          <div className='answer_container'>
            <DashboardCheckbox
              onChange={handlePortalCheckChange}
              checked={values?.userLoginBlock?.value?.portal?.unblockAfterTimePeriod}
              name='unblockAfterTimePeriod'
              label='Yes'
            />
          </div>
        </IndentWrapper>

        <IndentWrapper indent={2}>
          <QuestionHeading>Time Period In Portal</QuestionHeading>
          <div className='answer_container'>
            <Input
              value={values?.userLoginBlock?.value?.portal?.timePeriod}
              onChange={handlePortalValueChange}
              name='timePeriod'
              type='number'
              onKeyDown={handleKeyDown}
            />
          </div>
        </IndentWrapper>

        <div className='form_header'>
          <BorderHeading>Deactivate Inactive User Configration</BorderHeading>
        </div>

        <IndentWrapper indent={1}>
          <QuestionHeading>
            Inactivity Days after which user will be deactivated
          </QuestionHeading>
          <div className='answer_container'>
            <Input
              value={values?.userInactivityBlock?.value?.inactivityConfigDays}
              onChange={handleInactivityValueChnage}
              name='inactivityConfigDays'
              type='number'
              onKeyDown={handleKeyDown}
            />
          </div>
        </IndentWrapper>
        <IndentWrapper indent={1}>
          <QuestionHeading>Designations to be deactivated</QuestionHeading>
          <div className='multiselect_answer_container'>
            <GenricMultiSelect
              label='Designations'
              selectedOptions={values?.userInactivityBlock?.value?.designationToBlockOnInactivity}
              options={allDesignations}
              handleMultiSelectState={(selectedOptions: string[]) => {
                setValues({
                  ...values,
                  userInactivityBlock: {
                    ...values.userInactivityBlock,
                    value:{
                      ...values.userInactivityBlock.value,
                      designationToBlockOnInactivity:selectedOptions 
                    }
                  },
                });
              }}
              isRequired={false}
            />
          </div>
        </IndentWrapper>
      </div>
    </div>
  );
};

export default PasswordConfiguration;
